export default __webpack_public_path__ + "images/1659bb822fb19ca713fe47df372d54c8-edmelectronic.jpg";